import React from 'react';

import PropTypes from 'prop-types';

import { AnimatedIconFail } from 'apps/promo/components/common/AnimatedIcon/AnimatedIconFail';
import { AnimatedIconSuccess } from 'apps/promo/components/common/AnimatedIcon/AnimatedIconSuccess';

import { CenterContainer, Container, HeaderText, MainText, RowButtonContainer, SecondaryText } from './styles';
import { LightButton } from '../fromAuth/LightButton/LightButton';
import { LightDiskButton } from '../fromAuth/LightDiskButton/LightDiskButton';
import { LightFixedBottomPanel } from '../fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { LightIcon } from '../fromAuth/LightIcon/LightIcon';
import { LightNavBar } from '../fromAuth/LightNavBar/LightNavBar';

export const PromoInfoPage = (props) => {
    return (
        <Container data-testid={props.dataTestId} insideModalComponent={props.insideModalComponent}>
            {(props.backUrl || props.topButtonCaption) && (
                <LightNavBar align={props.backUrl ? 'left' : 'right'}>
                    {props.backUrl && (
                        <LightDiskButton
                            type={props.isTagA ? 'tagA' : null}
                            to={props.backUrl}
                            href={props.backUrl}
                            iconName={props.leftCloseIcon ? 'cross' : 'arrow-back'}
                            onClick={props.diskButtonOnClick}
                        />
                    )}
                    {props.topButtonCaption && (
                        <LightButton
                            type={props.topButtonType}
                            variant="tertiary"
                            size="tight"
                            caption={props.topButtonCaption}
                            onClick={props.topButtonOnClick}
                            href={props.topButtonLink}
                        />
                    )}
                </LightNavBar>
            )}
            <CenterContainer>
                <div>
                    {props.iconName && <LightIcon name={props.iconName} color={props.iconColor} size="80px" />}
                    {!props.iconName && props.iconSrc && <img src={props.iconSrc} alt="" />}
                    {!props.iconName && !props.iconSrc && props.animatedIconSuccess && <AnimatedIconSuccess />}
                    {!props.iconName && !props.iconSrc && props.animatedIconFail && <AnimatedIconFail />}
                </div>
                {/* Для фиолетового выделения следующая конструкция: <><span>{purpleText}</span>{headerText}</span></>*/}
                {props.headerText && <HeaderText>{props.headerText}</HeaderText>}
                {props.secondaryText && <SecondaryText>{props.secondaryText}</SecondaryText>}
                {/* текст небольшого размера */}
                {props.mainText && (
                    <MainText hasBorder={props.hasBorder} breakWord={props.breakWord}>
                        {props.mainText}
                    </MainText>
                )}
                {props.buttonRowCaption && (
                    <RowButtonContainer>
                        <LightButton
                            type={props.buttonRowType}
                            variant="row"
                            size="tight"
                            negativeMargin
                            caption={props.buttonRowCaption}
                            onClick={props.buttonRowOnClick}
                            target={props.buttonRowTarget}
                            href={props.buttonRowHref}
                            rel={props.buttonRowRel}
                        />
                    </RowButtonContainer>
                )}
            </CenterContainer>
            {props.primaryButtonCaption && (
                <LightFixedBottomPanel>
                    <LightButton
                        dataTestId={props.primaryButtonDataTestId}
                        type={props.primaryButtonType}
                        raised="true"
                        caption={props.primaryButtonCaption}
                        onClick={props.primaryButtonOnClick}
                        href={props.primaryButtonLink}
                        to={props.primaryButtonLink}
                    />
                </LightFixedBottomPanel>
            )}
        </Container>
    );
};

PromoInfoPage.propTypes = {
    topButtonCaption: PropTypes.string,
    topButtonType: PropTypes.string,
    topButtonOnClick: PropTypes.func,
    topButtonLink: PropTypes.string,
    iconName: PropTypes.string,
    iconSrc: PropTypes.string,
    iconColor: PropTypes.string,
    animatedIconSuccess: PropTypes.bool,
    animatedIconFail: PropTypes.bool,
    headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    mainText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hasBorder: PropTypes.bool,
    buttonRowType: PropTypes.string,
    buttonRowTarget: PropTypes.string,
    buttonRowRel: PropTypes.string,
    buttonRowCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonRowOnClick: PropTypes.func,
    primaryButtonCaption: PropTypes.string,
    primaryButtonType: PropTypes.string,
    primaryButtonOnClick: PropTypes.func,
    primaryButtonLink: PropTypes.string,
    primaryButtonDataTestId: PropTypes.string,
    buttonRowHref: PropTypes.string,
    insideModalComponent: PropTypes.bool, // если PromoInfoPage находится в модалке
    isTagA: PropTypes.bool,
    breakWord: PropTypes.bool,
    backUrl: PropTypes.string,
    leftCloseIcon: PropTypes.bool,
    diskButtonOnClick: PropTypes.func,
    dataTestId: PropTypes.string,
};
